import { formatNumber } from '@progress/kendo-intl';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import useRedirect from 'src/hooks/useRedirect';
import { round } from 'src/utils/number';
import { useContextSelector } from 'use-context-selector';
import ShoppingListDropdown from './ShoppingListDropdown';
import { ShoppingListProductsContext } from './ShoppingListProductsContext';

const ShoppingListProductsHeader = () => {
  const { t } = useTranslation();
  const { getUrl, redirect } = useRedirect();
  const shoppingList = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.shoppingList
  );
  const glCodeDisplay = shoppingList?.glCode ?? t('Unassigned');

  const handleBack = () => {
    redirect(getUrl('viewShoppingLists'), false, false);
  };

  return (
    <div className="flex w-full min-w-0 flex-col px-4 py-2">
      <div className="shopping-list-products-header__row flex min-w-0 flex-col items-start gap-2 lg:flex-row lg:items-center">
        <div className="flex min-w-0 max-w-full flex-col gap-1.5 lg:flex-1">
          <ShoppingListDropdown />
          <p className="flex min-w-0 items-center gap-1 text-xs font-normal leading-tight text-[#111827]">
            <span className="flex min-w-0 shrink items-center overflow-hidden">
              <span className="shrink-0">{t('GL Code')}:</span>{' '}
              <span
                className="min-w-0 truncate"
                data-tooltip-id="global-tooltip"
                data-tooltip-content={glCodeDisplay}
              >
                {glCodeDisplay}
              </span>
            </span>
            <span className="shrink-0 whitespace-nowrap">
              | {t('Remaining Forecast Balance')}:{' '}
              {formatNumber(round(shoppingList?.glCodeBudget ?? 0, 2), 'c2')}
            </span>
          </p>
        </div>
        <Button color="secondary" size="lg" className="!m-0 w-fit shrink-0" onClick={handleBack}>
          {t('Back to Shopping Lists')}
        </Button>
        <div className="hidden min-w-0 lg:block lg:flex-1" />
      </div>
    </div>
  );
};

export default ShoppingListProductsHeader;
